<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Nuevo Recordatorio</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row dense>
            <v-col cols="9" sm="6" md="7">
              <v-text-field
                v-model="titulo"
                prepend-icon="mdi-message-text"
                label="Título *"
                dense
                required
                :rules="requiredRules"
                maxlength="100"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="texto"
                prepend-icon="mdi-message-text"
                label="Texto *"
                :rules="requiredRules"
                clearable
                :auto-grow="true"
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="fechaDesde"
                :value="fechaDesde"
                label="Fecha Vigencia Desde *"
                :rules="requiredRules"
                prepend-icon="mdi-calendar"
                type="date"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="fechaHasta"
                :value="fechaHasta"
                label="Fecha Vigencia Hasta *"
                :rules="requiredRules"
                prepend-icon="mdi-calendar"
                type="date"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="notifica-checkbox">
              <v-checkbox
                v-model="notifica"
                label="Genera Notificación"
                color="primary"
                :disabled="notificaFlag"
                dense
              ></v-checkbox>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="usuariosSeleccionados"
                :items="usuarios"
                item-text="nombreUsuarioCompleto"
                item-value="usuario"
                :menu-props="{ maxHeight: '400' }"
                label="Usuarios *"
                multiple
                chips
                :deletable-chips="true"
                hint="Usuarios que verán el recordatorio"
                persistent-hint
                no-data-text="No hay Usuarios configurados"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey lighten-1" @click.stop="show = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="success"
            :disabled="!valid || !usuariosSeleccionados.length"
            @click.stop="guardarRecordatorio"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<style lang="scss" scoped>
.notifica-checkbox {
  .v-input--checkbox {
    margin-top: 1.2rem;
    padding-top: 0;
    margin-left: 1rem;
  }
}
</style>
<script>
import axios from "@/axios-auth";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    titulo: "",
    texto: "",
    fechaDesde: "",
    fechaHasta: "",
    usuariosSeleccionados: [],
    usuarios: [],
    notifica: false,
  }),

  props: {
    visible: {
      type: Boolean,
    },
    notificaFlag: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    show: {
      get() {
        if (this.visible) this.setearModels();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    guardarRecordatorio() {
      this.$swal({
        title: "Guardar Recordatorio",
        text: "¿Desea registrar el recordatorio?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const datosRecordatorio = {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            titulo: this.titulo,
            texto: this.texto,
            fechaDesde: this.fechaDesde,
            fechaHasta: this.fechaHasta,
            usuarios: this.usuariosSeleccionados,
            notifica: this.notifica,
            usuarioCreador: this.$store.state.usuario.usuario,
          };
          let self = this;

          if (datosRecordatorio.fechaDesde > datosRecordatorio.fechaHasta) {
            self.showAlert({
              icon: "error",
              title: "La fecha desde no puede ser mayor que la fecha hasta",
              vm: this,
            });
            return;
          }

          axios
            .get("/Usuario/GuardarRecordatorio", {
              params: {
                idInstitucion: datosRecordatorio.idInstitucion,
                titulo: datosRecordatorio.titulo,
                texto: datosRecordatorio.texto,
                fechaDesde: datosRecordatorio.fechaDesde,
                fechaHasta: datosRecordatorio.fechaHasta,
                usuarios: datosRecordatorio.usuarios,
                notifica: datosRecordatorio.notifica,
                usuarioCreador: datosRecordatorio.usuarioCreador,
              },
            })
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarModels();
              document.getElementsByClassName(
                "v-dialog--active",
              )[0].scrollTop = 0;
              self.showAlert({
                icon: "success",
                title: "Recordatorio Registrado",
                vm: self,
              });
              self.$emit("recordatorioRegistrado");
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "El recordatorio no pudo ser registrado",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    setearModels() {
      this.fechaDesde = this.parseDate(
        this.formatDate(this.toISOLocal(new Date())),
      );

      this.usuarios = [];
      this.usuariosSeleccionados = [];
      let self = this;
      axios
        .get("/Usuario/BuscarUsuarios?", {
          params: {
            idInstitucion: self.$store.state.usuario.institucion.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.usuarios = response.data
              .filter((obj) => !obj.usuario.toLowerCase().includes("tokia"))
              .map((item) => {
                const grupo = item.nombreGrupoUsuario?.trim();
                return {
                  ...item,
                  nombreUsuarioCompleto: grupo
                    ? `${item.usuario} - (${grupo})`
                    : item.usuario,
                  _tieneGrupo: !!grupo, // campo auxiliar para ordenar
                };
              })
              .sort((a, b) => {
                if (a._tieneGrupo && !b._tieneGrupo) return -1;
                if (!a._tieneGrupo && b._tieneGrupo) return 1;

                // Si ambos tienen grupo (o ambos no), ordeno alfabéticamente por grupo
                const grupoA = a.nombreGrupoUsuario?.toLowerCase() || "";
                const grupoB = b.nombreGrupoUsuario?.toLowerCase() || "";
                return grupoA.localeCompare(grupoB);
              });
          else self.usuarios = [];
        })
        .catch(function (error) {});

      this.usuariosSeleccionados = [this.$store.state.usuario.usuario];

      if (this.notificaFlag) {
        this.notifica = true;
      }
    },

    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    toISOLocal(d) {
      var z = (n) => ("0" + n).slice(-2);
      var zz = (n) => ("00" + n).slice(-3);
      var off = d.getTimezoneOffset();
      var sign = off < 0 ? "+" : "-";
      off = Math.abs(off);
      return (
        d.getFullYear() +
        "-" +
        z(d.getMonth() + 1) +
        "-" +
        z(d.getDate()) +
        "T" +
        z(d.getHours()) +
        ":" +
        z(d.getMinutes()) +
        ":" +
        z(d.getSeconds()) +
        "." +
        zz(d.getMilliseconds()) +
        "Z"
      )
        .toString()
        .substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    vaciarModels() {
      this.titulo = "";
      this.texto = "";
      this.fechaDesde = "";
      this.fechaHasta = "";
      this.usuariosSeleccionados = [];
      this.notifica = false;
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
  },

  created() {
    this.vaciarModels();
  },
};
</script>
